"use client";

import React from "react";
import { Cpu, MonitorSmartphone, Wrench, Headphones } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Petroleum Refining",
  description: "High-precision engineering solutions for downstream operations, optimizing distillation and catalytic cracking processes with industrial-grade control systems.",
  icon: Cpu
}, {
  title: "Petrochemical Processing",
  description: "Specialized infrastructure for hydrocarbon conversion, ensuring maximum yield and safety in high-pressure olefin and aromatic production environments.",
  icon: MonitorSmartphone
}, {
  title: "Chemical Manufacturing",
  description: "Ruggedized batch processing systems designed for corrosive environments, adhering to strict safety protocols and rigorous throughput requirements.",
  icon: Wrench
}, {
  title: "Industrial Process Plants",
  description: "End-to-end automation and monitoring for complex thermal and mechanical plants requiring continuous operation and performance monitoring.",
  icon: Headphones
}];
export default function CustomerServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}